import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'src/app/redux/hook';
import { axios, axiosUtils } from 'src/app/utils';
import systemConfig, { LOGIN_URL } from 'src/configs/system.config';
import { finalUrlsConfig, urlConfigSetter } from 'src/configs/url.config';

const ProtectedRoute = () => {
  const user = useAppSelector((state) => state.user);
  const location = useLocation();
  const [hasData, setHasData] = useState<any>();
  const dispatch = useAppDispatch();

  const getUrlsData = async () => {
    try {
      const { data }: { data: Record<string, Record<string, string>> } = await axios(
        finalUrlsConfig().controlPanel.wakeUpUrls,
      );
      axiosUtils.configureInterceptors(
        dispatch,
        (error: any) => false,
        (config, instance) => {
          // if (instance.key === 'wb') {
          //   config.baseURL = `http://${data.webBackend.host}:${data.webBackend.port}/api`;
          // }
          if (instance.key === 'surfer') {
            config.baseURL = data.surfer ? `https://${data.surfer.host}/surfer` : window.SURFER_URL;
          }
          // if (instance.key === 'systemLogin') {
          //   config.baseURL = data.systemLoginBackend
          //     ? `https://${data.systemLoginBackend.host}/loginApi`
          //     : window.SYSTEM_LOGIN_URL;
          // }
          if (instance.key === 'systemLogin') {
            config.baseURL = window.SYSTEM_LOGIN_URL;
          }
          if (instance.key === 'messenger') {
            config.baseURL = data.messenger ? `https://${data.messenger.host}/messenger` : window.CPP_MESSENGER_URL;
          }
        },
      );
      urlConfigSetter(data);
      return data;
    } catch (error) {
      console.log('error', error);
    }
  };

  useEffect(() => {
    const data = getUrlsData();
    setHasData(data);
  }, []);
  if (!hasData) return null;
  if (!user.token || !user.roles.length) {
    // If the user is not logged in, save the target URL in localStorage

    if (location.pathname === '/Notifications') {
      const url = new URLSearchParams(window.location.search);
      const notificationId = url.get('id');
      if (notificationId) {
        if (systemConfig.systemLogin.active) {
          window.location.replace(
            `${finalUrlsConfig().systemLoginURL}/Login?${encodeURIComponent(`notifications=${notificationId}`)}`,
          );
        } else {
          localStorage.setItem('redirectAfterLogin', location.pathname + location.search);
          window.location.replace(LOGIN_URL);
        }
      }
    } else if (location.pathname !== '/') {
      localStorage.setItem('redirectAfterLogin', location.pathname + location.search);
      window.location.replace(LOGIN_URL);
    }
    // Redirect to the login page using a full URL

    // window.location.replace(LOGIN_URL);
    return null;
  }
  return <Outlet />;
};

export default ProtectedRoute;
